import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatMad' })
export class FormatNumberPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') return '---';
    const num = Number(value);
    if (isNaN(num)) return '---';
    return num.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
// @Pipe({ name: 'formatMad' })
// export class FormatNumberPipe implements PipeTransform {
//   transform(value: any): string {
//     if (value === null || value === undefined || value === '') return '---';
//     const num = Number(value);
//     if (isNaN(num)) return '---';

//     // Formatage manuel : séparateur de milliers = espace, décimales = virgule
//     const parts = num.toFixed(2).split('.');
//     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
//     return parts.join(',');
//   }
// }